import { useReducer, useEffect, useRef } from "react";
import { useFiltersContext } from "../contexts/filters";
import { useSettingsContext } from "../contexts/settings";
import getPosts from "../externals/getPosts";

const initialState = {
    posts: [],
    page: 1,
    maxNumPages: 1,
    foundPosts: 1,
}

const actions = {
    SET_POSTS: "SET_POSTS",
    ADD_POSTS: "ADD_POSTS",
    SET_PAGE: "SET_PAGE",
    SET_LOADING: "SET_LOADING",
}

const reducer = (state, action) => {
    switch (action.type) {
        case actions.SET_POSTS : {
            return {
                ...state,
                posts: action.payload.posts,
                page: 1,
                maxNumPages: action.payload.max_num_pages,
                foundPosts: action.payload.found_posts,
                loading: false,
            }
        }

        case actions.ADD_POSTS : {
            return {
                ...state,
                posts: [
                    ...state.posts,
                    ...action.payload.posts,
                ],
                loading: false,
            };
        }

        case actions.SET_PAGE : {
            return {
                ...state,
                page: action.payload.page,
            };
        }

        case actions.SET_LOADING : {
            return {
                ...state,
                loading: action.payload.isLoading,
            };
        }

        default: {
            return state;
        }
    }
}

const usePosts = () => {
    const [ state, dispatch ] = useReducer( reducer, initialState );
    const settings = useSettingsContext();
    const { selectedTax } = useFiltersContext();

    useEffect(() => {
        dispatch({ type: actions.SET_LOADING, payload: { isLoading: true } });

        const fetchData = async () => {
            const response = await getPosts( settings, selectedTax );
            dispatch({ type: actions.SET_POSTS, payload: response });
        }

        fetchData().catch( console.error );
    }, [ selectedTax ] );
    
    // On page change, add posts. Prevent adding on remounts by storing a ref of prev page.
    const prevPage = useRef([ state.page, selectedTax ]);
    useEffect(() => {
        if ( 1 === state.page || prevPage.current === state.page ) {
            return;
        }

        const fetchData = async () => {
            const response = await getPosts( settings, selectedTax, state.page );
            dispatch({ type: actions.ADD_POSTS, payload: response });
            prevPage.current = [ state.page, selectedTax ]
        }

        fetchData().catch( console.error );
    }, [ state.page ] );

    return {
        posts: state.posts,
        page: state.page,
        maxNumPages: state.maxNumPages,
        loading: state.loading,
        setPage: (page) => {
            dispatch({ type: actions.SET_PAGE, payload: { page: page } });
        },
        setLoading: (isLoading) => {
            dispatch({ type: actions.SET_PAGE, payload: { isLoading: isLoading } });
        }
    }
}

export default usePosts;
